import axios from 'axios';

export const cronApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/service-cron`,
    headers: {
        'Content-Type': 'application/json'
    }
})